export default "__VITE_ASSET__Baaz5MXL__"